import React from 'react';
import { Link } from 'react-router-dom';
import imagesData from '../data/images';
import './Gallery.css';

function Gallery() {
  return (
    <div>
      <h2>Galeria</h2>
      <div className="gallery-container">
        {imagesData.map((img) => (
          <div className="gallery-item" key={img.id}>
            {/* Kliknięcie przeniesie do /galeria/:id */}
            <Link to={`/galeria/${img.id}`}>
              <img src={img.src} alt={img.title} />
            </Link>
            <div className="gallery-caption">{img.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;
